/**
 * Created by greg on 20/07/2018.
 */
import { getUTCOffset } from './helpers';
import { SecondaryTimeZoneData } from '../store/programs.data';

export class TimeHelper {
  getMinutes(twentyFour:string):number{
    let num = 0, hours, mins, isAm, isPm
    if (typeof twentyFour !== 'string') return 0

    twentyFour = twentyFour.toLowerCase()
    isAm = twentyFour.includes('am')
    isPm = twentyFour.includes('pm')

    twentyFour = twentyFour.replace(/am|pm/g, '')

    if (!twentyFour.includes(':')) {
      if (twentyFour.includes('.')) {
        twentyFour = twentyFour.replace('.',':')
      } else if (twentyFour.length > 2) {
        twentyFour = twentyFour.replace(/(.+)(.{2})/, '$1:$2');
      } else {
        twentyFour = twentyFour + ':00'
      }
    }

    // console.log({ twentyFour })

    const hands = twentyFour.split(':').map(x=>parseInt(x, 10));

    hours = hands[0]
    mins = hands[1]

    // console.log({ hours, mins })

    if (isPm) {
        hours = hands[0] + (hands[0] < 12 ? 12 : 0);
    } else if (isAm) {
        hours = hands[0] - (hands[0] >= 12 ? 12 : 0);
    } else if (hands[0] === 24 && hands[1] === 0)  {
        hours = 0;
    }

    num = hours * 60 + mins;
    if(isNaN(num) || num < 0) num = 0;
    if(num > 1439) num = 1439;
    return num;
  } 
  getTwentyFour(minutes:number):string{
    if(minutes > 1439) minutes = 1439;
    if(minutes < 0) minutes = 0;
    let str = '';
    let hours = Math.floor(minutes/60);
    let mins = minutes%60;
    if(isNaN(hours)) hours = 0;
    if(isNaN(mins)) mins = 0;
    str = this.dubdig(hours)+':'+this.dubdig(mins);
    return str;
  }
  dubdig(dig:any):string{
    if(typeof dig === 'string' ){
        if(dig.length === 1) return '0'+dig;
    }else if(typeof dig === 'number'){
        if(dig < 10) return '0'+dig;
    }
    return dig.toString();
  }

  parseTime(twentyFour: string): string {
    return this.getTwentyFour(this.getMinutes(twentyFour))
  }

  getSecondaryTimeData(epoch: number, offset:number, timeZoneId:string, startOfDay:number, endOfDay:number):SecondaryTimeZoneData {
    
    const secondaryOffset = getUTCOffset(timeZoneId, new Date(epoch));
    const diff = offset - secondaryOffset.offset;
    const new_date = new Date( 1000 * 60 * 60 * diff + epoch )
    const new_date_epoch = new_date.getTime();
    const dayOffset = new_date_epoch < startOfDay || new_date_epoch > endOfDay ? new_date.getDate()+' '+new_date.toLocaleString('default', { month: 'short' }) : null;
    const time = this.dubdig(new_date.getHours())+':'+this.dubdig(new_date.getMinutes());
    // console.log({ epoch, offset, timeZoneId, startOfDay, endOfDay, time, dayOffset })
    return { time, dayOffset }
  }
}

export const timeHelper = new TimeHelper()